import React, {useState, useEffect} from 'react'
import cn from "classnames"
import pageBg from  '../../img/mountain-bg.webp'
import modalBg from '../../img/waterfall-modal-bg.svg'
import contentImg1 from '../../img/markov_3.webp'
import {Preloader, SpriteSvg} from '../../components'
import {useMousePosition} from '../../utils'
import sun2 from "../../img/sun2.png";
import sun3 from "../../img/sun3.png";
import sun4 from "../../img/sun4.png";
import sun5 from "../../img/sun5.png";
import sun6 from "../../img/sun6.png";
import bgImg1 from "../../img/mountain-bgImg1.webp";
import bgImg2 from "../../img/mountain-bgImg2.webp";
import bgImg3 from "../../img/mountain-bgImg3.webp";

const MountainPage = ({
	handleNextPage,
	name,
	isLoaded,
	setIsLoaded,
	isRouteTraveled,
	setIsRouteTraveled,
	mountainPage,
	afterMountainGamePage,
}) => {

const [isVisibleContent, setIsVisibleContent] = useState(false)
const [isVisiblePage, setIsVisiblePage] = useState(true)
	const [isVisibleGame, setIsVisibleGame] = useState(false)
const [modalContentChange, setModalContentChange] = useState('1')

	useEffect(()=> {
		window.TN_BALANCE.run("#area");
		setTimeout(()=> {
			setIsVisibleContent(true)
		},7000)
	},[])

	//СТАРТ ИГРЫ
	const handleGame = () => {
		setIsVisiblePage(false)
		setIsVisibleGame(true)
		window.TN_BALANCE.showStartMessage()
		window.TN_BALANCE.successCallback = () => {
			setIsRouteTraveled([...isRouteTraveled, mountainPage])
			setIsVisibleGame(false)
			handleNextPage(afterMountainGamePage)
		}
	}
	const position = useMousePosition()

	return (
		<>
		<Preloader isLoaded={isLoaded} setIsLoaded={setIsLoaded}/>
			<div id='area' className={cn(
				'game-wrap',
				isVisibleGame && 'active'
			)}></div>

			{isVisiblePage &&
		<div className={cn(
					 'full-page',
					 'peacs-page',
					 isLoaded && 'active'
				 )}
		>
			<div className="page-bg right-sun">
				<img className='bg-img' src={pageBg} alt=""/>
				<img className='sun2' style={{transform: `translate(-${position.x / 10}px, -${position.y / 10}px)`}} src={sun2} alt=""/>
				<img className='sun3' style={{transform: `translate(-${position.x / 25}px, -${position.y / 25}px)`}} src={sun3} alt=""/>
				<img className='sun4' style={{transform: `translate(-${position.x / 50}px, -${position.y / 50}px)`}} src={sun4} alt=""/>
				<img className='sun5'  src={sun5} alt=""/>
				<img className='sun6' style={{transform: `translate(${position.x / 150}px, ${position.y / 150}px)`}} src={sun6} alt=""/>
				<img className='mountain-bgImg1' style={{transform: `translate(-${position.x / 450}px, -${position.y / 450}px)`}} src={bgImg1} alt=""/>
				<img className='mountain-bgImg2' style={{transform: `translate(${position.x / 250}px, ${position.y / 250}px)`}} src={bgImg2} alt=""/>
				<img className='mountain-bgImg3' style={{transform: `translate(-${position.x / 150}px, -${position.y / 150}px)`}} src={bgImg3} alt=""/>
			</div>

			<div className={cn(
						 'page-content',
						 isVisibleContent &&
						 'active'
					 )}>

				<div className={cn(
					'modal',
					modalContentChange !== '1' &&
					'disabled'
				)}
				>
					<div className="modal-bg">
						<img src={modalBg} alt=""/>
					</div>


					<div className={cn(
						'modal-content'
					)}
					>
						<div className="text">
							<p className='mg-b-24'>Ну вот мы и на финишной прямой! Это был долгий путь. Пройдено множество преград, и тебе всё было по плечу!</p>
							<p className='mg-b-24'>Не забудь взять с собой флаг покорителя вершины, остался последний рывок! Стань тем, кто подчинит горную вершину ТЕХНОНИКОЛЬ и водрузит флаг.</p>
						</div>

						<div className="btn-wrap jcs">
							<div onClick={()=> setModalContentChange('2')} className="btn green" style={{width: '190px'}}>
								<SpriteSvg id='train-station-page-btn-green-bg'/>
								<span>Взять флаг у девушки</span>
							</div>
						</div>
					</div>

				</div>

				<div className={cn(
					'modal',
					modalContentChange !== '2' &&
					'disabled'
				)}
				>
					<div className="modal-bg">
						<img src={modalBg} alt=""/>
					</div>

					<div className={cn(
						'modal-content',
					)}
					>
						<div className="text">
							<p className='mg-b-24'>Мы находимся на склоне горы, прямо на леднике. Из-за сильной пурги практически ничего не видно. Этот путь тебе нужно пройти в одиночку! Ты справишься! Пик ждал тебя 30 лет!</p>

								<p className='mg-b-24'>Удачи тебе, {name}!</p>
						</div>

						<div className="btn-wrap jcs">
							<div onClick={()=> handleGame()} className="btn green" style={{width: '190px'}}>
								<SpriteSvg id='train-station-page-btn-green-bg'/>
								<p>Достигнуть пика</p>
							</div>
						</div>
					</div>

				</div>

				<div className={cn(
					'content',
					'center',
				)}>
					<div className="img-wrap">
						<img src={contentImg1} alt=""/>
					</div>

				</div>

			</div>

		</div>
			}
		</>
	)
}

export default MountainPage